import "./navigationHeader.css";
import { routes } from "../../routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/slices/authSlice";
import { profileImages } from "../../utils/globalImages";

function NavigationHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="container-fluid hide-on-mobile-screen">
      <div className="row d-space-between navigation-container">
        <div className="col-6">
          <button
            className="navigation-arrow-btn"
            onClick={() => {
              if (window.history.length > 1) {
                navigate(-1);
              } else {
                navigate(routes.HOME);
              }
            }}
          >
            <i className="fa-solid fa-angle-left"></i>
          </button>
          <span className="text-22px text-fw-400 ml-24px text-AktivGrotesk-Bold">My Profile</span>
        </div>
        <div className="col-6 d-end">
          <button
            className="logout-btn d-center"
            onClick={() => dispatch(logout())}
          >
            <img src={profileImages.logout} alt="Logout Image" />
            <span className="m-icon-left text-AktivGrotesk-Medium">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default NavigationHeader;
